<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { MainMenuItems } from '@/helpers/enums';

  export default defineComponent({
    mixins: [Mixins],
    props: {
      active: { type: Boolean, default: false },
      menuItem: { type: String as () => MainMenuItems, required: true },
      notificationNumber: {
        type: Number as () => number | null,
        default: null,
      },
    },
    emits: {
      select: (item: MainMenuItems) => true,
    },
    computed: {
      label() {
        return this.$t(`main_menu.${this.menuItem.toLowerCase()}`);
      },
    },
  });
</script>

<template>
  <div
    :class="{ active: active }"
    class="main-menu-item"
    @click="$emit('select', menuItem)"
  >
    <div class="main-menu-item--img-wrapper d-flex align-items-center">
      <img
        :alt="$t('common.img_alts.inactive')"
        :src="imgUrl(`icons/main_menu/${menuItem.toLowerCase()}.svg`)"
        class="img-inactive"
        height="24"
        width="24"
      />
      <img
        :alt="$t('common.img_alts.active')"
        :src="imgUrl(`icons/main_menu/${menuItem.toLowerCase()}_active.svg`)"
        class="img-active"
        height="24"
        width="24"
      />
      <small
        v-if="notificationNumber"
        class="main-menu-item--notification fw-bold text-white"
      >
        {{ notificationNumber >= 10 ? '9+' : notificationNumber }}
      </small>
    </div>
    <span>{{ label }}</span>
  </div>
</template>

<style lang="scss" scoped>
  .main-menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: 3px solid $white;
    padding-top: 1.125 * $base-unit;
    padding-bottom: 2 * $base-unit;
    cursor: pointer;

    font-size: 1.5 * $base-unit;
    line-height: 1.75 * $base-unit;
    font-weight: 600;
    color: $gray;

    transition: all 250ms;

    &--img-wrapper {
      position: relative;
    }

    &--notification {
      position: absolute;
      right: -0.8 * $base-unit;
      bottom: 0.5 * $base-unit;
      background: $accent-warning-red;
      border-radius: 50%;
      width: 2.5 * $base-unit;
      height: 2.5 * $base-unit;

      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    img {
      display: inline-block;
      margin-bottom: 0.875 * $base-unit;
    }

    .img-active {
      display: none;
    }

    &.active {
      border-top-color: $gray-black;
      color: $gray-black;

      .img-active {
        display: block;
      }

      .img-inactive {
        display: none;
      }
    }
  }
</style>
